<template>
  <div class="m-auto">
    <img src="/images/logo.svg" alt="Logo" style="width: auto; height: 40px;" class="m-auto" v-if="isAuth">
    <img src="/images/logo.svg" alt="Logo" style="width: auto; height: 120px;" class="m-auto" v-else>
  </div>
</template>
